import request from "@/utils/request"
// 公司列表(1)
export const concompany = (params) => {

    return request({
        method: "POST",
        data: {
           ...params
        },
        url: "/handle/baohan/con_company",
    });
};
export const zhaobiao = (params) => {

    return request({
        method: "POST",
        data: {
        ...params
        },
        url: "/handle/baohan/zhaobiao",
    });
};
export const zhongbiao = (params) => {

    return request({
        method: "POST",
        data: {
           ...params
        },
        url: "/handle/baohan/zhongbiao",
    });
};
// 保函列表(1)
export const bhlist = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/bhlist",
    });
};
export const gongchenginfo = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/index/gongchenginfo",
    });
};

// 公司列表(1)
export const bidding = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/bidding",
    });
};
// 生成保函数据(2)
export const generate = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/generate",
    });
};

export const jujue = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/jujue",
    });
};
export const wancheng = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/wancheng",
    });
};
export const guoqi = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/guoqi",
    });
};
export const daishen = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/daishen",
    });
};

// 公司列表(3)
export const getCompany = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/company",
    });
};
// 公司列表(3)
export const datatijiao = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/datatijiao",
    });
};
// 填写相关信息后调用
export const bidfrom = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/datasub",
    });
};
//保函详情
export const detail = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/index/detail",
    });
};
// 填写相关信息后调用
export const bhsh_list = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/bhsh_list",
    });
};
// 填写相关信息后调用
export const danbaoqianzhang = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/danbaoqianzhang",
    });
};
// 填写相关信息后调用
export const faren = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/farenqianzhang",
    });
};

// 填写相关信息后调用
export const baohanqianzhang = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/baohanqianzhang",
    });
};
// 填写相关信息后调用
export const zhenshi = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/zhenshiqianzhang",
    });
};
export const bhpay = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/danbaoqianzhang",
    });
};
export const enclosure = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/enclosure",
    });
};
//快递详情
export const sfdetail = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/kuaidi/sf_detail",
    });
};
//快递轨迹
export const sfroute = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/kuaidi/sf_route",
    });
};
//取消快递
export const sfcancel = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/kuaidi/sf_cancel",
    });
};
export const resubmit = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/api/fapiao/resubmit",
    });
};
export const bhpay2 = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/zhenshiqianzhang",
    });
};
export const bhpay3 = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/farenqianzhang",
    });
};
// 填写相关信息后调用
export const getpayinfo = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/getpayinfo",
    });
};
export const zhifuasd = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/Baohan/bhpay",
    });
};
export const paylist = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/paylist",
    });
};
export const ddch = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/ddch",
    });
};
export const grrz = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/handle/baohan/grrz",
    });
};
export const shebaolist = (params) => {

    return request({
        method: "POST",
        data: params,
        url: "/api/shebao/shebaolist",
    });
};
// 保函详情
export const bhdetail = (params) => {

        return request({
            method: "POST",
            data: params,
            url: "/handle/baohan/bhdetail",
        });
    };
    // 文件签章
export const qianzhang = (params) => {

        return request({
            method: "POST",
            data: params,
            url: "/handle/qianzhang/qianzhang",
        });
    };
        // 上传文件签章
export const scqianzhang = (params) => {

        return request({
            method: "POST",
            data: params,
            url: "/handle/qianzhang/scqianzhang",
        });
    };

    export const wenjian = (params) => {

            return request({
                method: "POST",
                data: params,
                url: "/handle/baohan/wenjian",
            });
        };
        
    export const getbhfile = (params) => {

            return request({
                method: "POST",
                data: params,
                url: "/handle/baohan/getbhfile",
            });
        };
        


// WEBPACK FOOTER //
// ./src/api/system/liucheng.js